import { render } from "./Principal-course.vue?vue&type=template&id=263f3363"
import script from "./Principal-course.vue?vue&type=script&lang=js"
export * from "./Principal-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__